import { capitalize } from '@/utils/strings';
import { ObjectTypes } from '../Store/utils';

/**
 * OBJECT TYPE FILTER
 */
export function getObjectTypeDescription(selectedObjectTypes?: ObjectTypes[] | null): string {
  const allObjectTypes = Object.values(ObjectTypes);

  if (
    !selectedObjectTypes ||
    selectedObjectTypes.length === 0 ||
    selectedObjectTypes.length === allObjectTypes.length
  ) {
    return 'Alla bostadstyper';
  }

  const missing = allObjectTypes.filter((name) => !selectedObjectTypes.includes(name));

  if (selectedObjectTypes.length >= allObjectTypes.length - 2) {
    return `Ej ${joinStrings(missing).toLowerCase()}`;
  }
  return capitalize(joinStrings(selectedObjectTypes).toLowerCase());
}

function joinStrings(items: string[]): string {
  items = items.sort();
  if (items.length === 0) return '';
  if (items.length === 1) return items[0];
  const allExceptLastItem = items.slice(0, -1).join(', ');
  const lastItem = items[items.length - 1];
  return `${allExceptLastItem} och ${lastItem}`;
}
